import { render, staticRenderFns } from "./PlayerTurnInfo.vue?vue&type=template&id=0275a982&scoped=true&"
import script from "./PlayerTurnInfo.vue?vue&type=script&lang=js&"
export * from "./PlayerTurnInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerTurnInfo.vue?vue&type=style&index=0&id=0275a982&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275a982",
  null
  
)

export default component.exports